<template>
  <div id="home" class="homeContainer">
    <el-row type="flex" justify="space-between">
      <el-col :span="6">
        <span class="label">月份筛选:</span>
        <el-select
          v-model="month"
          placeholder=""
          style="width: 90px"
          @change="changeMonth()"
        >
          <el-option
            v-for="(item, index) in monthList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="row">
      <el-col :span="16">
        <el-row :gutter="20" class="row">
          <el-col :span="12">
            <el-card>
              <el-row type="flex" justify="space-between">
                <el-col :span="9">
                  <div class="layout-1">
                    <img class="icon" src="../../static/image/todo-list.svg" width="80"/>
                    <span class="text-1">{{ toDoStatisticsVO.toDoTotal }}</span>
                    <span class="text-2">任务数量</span>
                    <span class="text-1 orange mt-10">{{ toDoStatisticsVO.toDoCompletionRate }}%</span>
                    <span class="text-2 orange">完成率</span>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="layout-2">
                    <span>系统名称</span>
                    <span v-for="(todoBySystem, index) in toDoStatisticsVO.toDoBySystems" :key="index">
                      {{ todoBySystem.systemName }}
                    </span>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="layout-2">
                    <span>任务数量</span>
                    <span v-for="(todoBySystem, index) in toDoStatisticsVO.toDoBySystems" :key="index">
                      {{ todoBySystem.toDoCount }}
                    </span>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="layout-2">
                    <span>任务完成率</span>
                    <span v-for="(todoBySystem, index) in toDoStatisticsVO.toDoBySystems" :key="index">
                      {{ todoBySystem.toDoCompletionRate }}%
                    </span>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card>
              <el-row type="flex" justify="space-between">
                <el-col :span="9">
                  <div class="layout-1">
                    <img class="icon" src="../../static/image/shop.svg" width="80"/>
                    <span class="text-1">{{ doorStatisticsVO.doorTotal }}</span>
                    <span class="text-2">店铺数量</span>
                    <span class="text-1 orange mt-10">{{ doorStatisticsVO.monthNew }}</span>
                    <span class="text-2 orange">本月新增</span>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="layout-2">
                    <span>系统名称</span>
                    <span v-for="(doorBySystem, index) in doorStatisticsVO.doorBySystems" :key="index">
                      {{ doorBySystem.systemName }}
                    </span>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="layout-2">
                    <span>门店数</span>
                    <span v-for="(doorBySystem, index) in doorStatisticsVO.doorBySystems" :key="index">
                      {{ doorBySystem.doorCount }}
                    </span>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="layout-2">
                    <span>本月新增</span>
                    <span v-for="(doorBySystem, index) in doorStatisticsVO.doorBySystems" :key="index">
                      {{ doorBySystem.monthNew }}
                    </span>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="row">
          <el-col :span="12">
            <el-card>
              <p class="chart-title">
                任务完成率
                <span>
<!--              详情-->
<!--              <img src="../../static/image/share.png" alt="">-->
            </span>
              </p>
              <div class="chart1" id="chart1">

              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card>
              <p class="chart-title">
                任务总量
                <span>
<!--              详情-->
<!--              <img src="../../static/image/share.png" alt="">-->
            </span>
              </p>
              <div class="chart1" id="chart10">

              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="8" class="row">
        <el-card>
          <el-row class="user-row" type="flex" justify="space-between">
            <el-col :span="5">
              <div class="layout-1 layout-3">
                <img class="icon" src="../../static/image/user.svg" width="80"/>
                <span class="text-1">{{ accountStatisticsVO.accountTotal }}</span>
                <span class="text-2">用户数量</span>
                <span class="text-1 orange mt-10">{{ accountStatisticsVO.activeUsers }}</span>
                <span class="text-2 orange">月活跃用户</span>
                <span class="text-1 orange mt-10">{{ accountStatisticsVO.activeDoors }}</span>
                <span class="text-2 orange">门店活跃</span>
              </div>
            </el-col>
            <el-col :span="19">
              <div class="layout-2 roleCard">
                <el-row class="roleRow roleRowHeader" :gutter="20">
                  <el-col :span="12">
                    <span>角色名称</span>
                  </el-col>
                  <el-col :span="5">
                    用户数
                  </el-col>
                  <el-col :span="7">
                    本月活跃用户
                  </el-col>
                </el-row>
                <div v-for="role in accountStatisticsVO.accountByRoles" :key="role.roleCode" class="text item">
                  <el-row class="roleRow" :gutter="20">
                    <el-col :span="12">
                      <span>{{ role.roleName }}</span>
                      <br>
<!--                      <span class="en">{{ role.roleCode }}</span>-->
                    </el-col>
                    <el-col :span="5">
                      <div style="text-align:center">{{ role.accountCount }}</div>
                    </el-col>
                    <el-col :span="7">
                      <div style="text-align:center">{{ role.activeUsers }}</div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="row">
      <el-col :span="24">
        <el-card>
          <p class="chart-title">
            用户活跃率
          </p>
          <div class="chart1" id="chart2">
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="row">
      <el-col :span="24">
        <el-card>
          <p class="chart-title">
            用户启动次数
          </p>
          <div class="chart1" id="chart3">
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="row">
      <el-col :span="24">
        <el-card>
          <p class="chart-title">
            人均启动次数
          </p>
          <div class="chart1" id="chart4">
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="row">
      <el-col :span="8">
        <el-card>
          <p class="chart-title">
            年-用户活跃率
          </p>
          <div class="chart1" id="chart5">

          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <p class="chart-title">
            年-用户启动次数
          </p>
          <div class="chart1" id="chart6">

          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <p class="chart-title">
            年-人均启动次数
          </p>
          <div class="chart1" id="chart7">

          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="row">
      <!-- <el-col :span="8">
        <el-card>
          <p class="chart-title">
            满意度
            <span @click="openSystem('listenUUrl')">
              详情
              <img src="../../static/image/share.png" alt="">
            </span>
          </p>
          <el-row>
            <el-col :span="12">
              <div class="layout-4">
                <div class="number">
                  {{ listenStatisticsVO.sampleCount }}
                  <span>
                    <i class="el-icon-top green" v-if="listenStatisticsVO.sampleCompare === 1"></i>
                    <i class="el-icon-bottom red" v-if="listenStatisticsVO.sampleCompare === -1"></i>
                    <i class="el-icon-right yellow" v-if="listenStatisticsVO.sampleCompare === 0"></i>
                  </span>
                </div>
                <div class="title">问卷数</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="layout-5">
                <p>
                  <span class="left">未购买率</span>
                  <span class="right">
                    {{ listenStatisticsVO.noPurchase }}%
                    <i class="el-icon-top green" v-if="listenStatisticsVO.noPurchaseCompare === 1"></i>
                    <i class="el-icon-bottom red" v-if="listenStatisticsVO.noPurchaseCompare === -1"></i>
                    <i class="el-icon-right yellow" v-if="listenStatisticsVO.noPurchaseCompare === 0"></i>
                  </span>
                </p>
                <p>
                  <span class="left">NPS</span>
                  <span class="right">
                    {{ listenStatisticsVO.nps }}%
                    <i class="el-icon-top green" v-if="listenStatisticsVO.npsCompare === 1"></i>
                    <i class="el-icon-bottom red" v-if="listenStatisticsVO.npsCompare === -1"></i>
                    <i class="el-icon-right yellow" v-if="listenStatisticsVO.npsCompare === 0"></i>
                  </span>
                </p>
                <p>
                  <span class="left">OSAT</span>
                  <span class="right">
                    {{ listenStatisticsVO.osat }}%
                    <i class="el-icon-top green" v-if="listenStatisticsVO.osatCompare === 1"></i>
                    <i class="el-icon-bottom red" v-if="listenStatisticsVO.osatCompare === -1"></i>
                    <i class="el-icon-right yellow" v-if="listenStatisticsVO.osatCompare === 0"></i>
                  </span>
                </p>
              </div>
            </el-col>
          </el-row>
        </el-card>

      </el-col> -->
      <el-col :span="8">
        <el-card>
          <p class="chart-title">
            巡店任务
            <span @click="openSystem('oprUrl')">
              详情
              <img src="../../static/image/share.png" alt="">
            </span>
          </p>
          <el-row>
            <el-col :span="12">
              <div class="layout-4">
                <div class="number">
                  {{ oprStatisticsVO.score.now }}
                  <span>
                    <i class="el-icon-top green" v-if="oprStatisticsVO.score.trend === 1"></i>
                    <i class="el-icon-bottom red" v-if="oprStatisticsVO.score.trend === -1"></i>
                    <i class="el-icon-right yellow" v-if="oprStatisticsVO.score.trend === 0"></i>
                  </span>
                </div>
                <div class="title">本月得分</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="layout-5">
                <p>
                  <span class="left">视觉成列</span>
                  <span class="right">
                    {{ oprStatisticsVO.analyse.nowVMS }}
                    <i class="el-icon-top green" v-if="oprStatisticsVO.analyse.trendVMS === 1"></i>
                    <i class="el-icon-bottom red" v-if="oprStatisticsVO.analyse.trendVMS === -1"></i>
                    <i class="el-icon-right yellow" v-if="oprStatisticsVO.analyse.trendVMS === 0"></i>
                  </span>
                </p>
                <p>
                  <span class="left">营运</span>
                  <span class="right">
                    {{ oprStatisticsVO.analyse.nowOPERATION }}
                    <i class="el-icon-top green" v-if="oprStatisticsVO.analyse.trendOPERATION === 1"></i>
                    <i class="el-icon-bottom red" v-if="oprStatisticsVO.analyse.trendOPERATION === -1"></i>
                    <i class="el-icon-right yellow" v-if="oprStatisticsVO.analyse.trendOPERATION === 0"></i>
                  </span>
                </p>
                <p>
                  <span class="left">培训</span>
                  <span class="right">
                    {{ oprStatisticsVO.analyse.nowTRAINING }}
                    <i class="el-icon-top green" v-if="oprStatisticsVO.analyse.trendTRAINING === 1"></i>
                    <i class="el-icon-bottom red" v-if="oprStatisticsVO.analyse.trendTRAINING === -1"></i>
                    <i class="el-icon-right yellow" v-if="oprStatisticsVO.analyse.trendTRAINING === 0"></i>
                  </span>
                </p>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>

      <el-col :span="16">
        <el-card>
          <p class="chart-title">
            工具使用情况
          </p>
          <el-row :gutter="60">
            <el-col :span="8" class="layout-7">
              <el-row :gutter="20">
                <el-col :span="20">
                  <!-- <p>满意度定制问卷发布数</p> -->
                  <p>开放问卷发布数</p>
                  <p>巡店任务检查数</p>
                  <p>活动陈列活动数</p>
                </el-col>
                <el-col :span="4">
                  <!-- <p>{{ toolUsageVO.listenPublishCount }}</p> -->
                  <p>{{ toolUsageVO.openQuestionnairesPublishCount }}</p>
                  <p>{{ toolUsageVO.oprCount }}</p>
                  <p>{{ toolUsageVO.vmsCount }}</p>
                </el-col>
              </el-row>
            </el-col>
            <!-- <el-col :span="8" class="layout-8">
              <p style="font-weight: 600">
                <el-row :gutter="20">
                  <el-col :span="20">
                    RetailLOG巡店次数
                  </el-col>
                  <el-col :span="4">
                    {{ toolUsageVO.taskCount }}
                  </el-col>
                </el-row>
              </p>
              <el-row :gutter="20">
                <el-col :span="20">
                  <p v-for="(region, index) in toolUsageVO.regions" :key="index">
                    {{ region.name }}
                  </p>
                </el-col>
                <el-col :span="4">
                  <p v-for="(region, index) in toolUsageVO.regions" :key="index">
                    {{ region.count }}
                  </p>
                </el-col>
              </el-row>
            </el-col> -->

          </el-row>


        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="row">
<!--vms暂时不要
<el-col :span="8">
        <el-card>
          <p class="chart-title">
            VMS
            <span>
              详情
              <img src="../../static/image/share.png" alt="">
            </span>
          </p>
          <el-row>
            <el-col :span="24">
              <div class="layout-6">
                <div class="circle">
                  <canvas id="canvas1"></canvas>
                </div>
                <p>活动上传率</p>
              </div>
            </el-col>
          </el-row>

        </el-card>

        &lt;!&ndash;playbook暂时不要了
                <el-card>
                  <p class="chart-title">
                    PlayBook
                    <span>
                      详情
                      <img src="../../static/image/share.png" alt="">
                    </span>
                  </p>
                  <p class="wait">敬请期待</p>
                </el-card>&ndash;&gt;
      </el-col>-->

<!--retaillog 暂时不要
        <el-card>
          <p class="chart-title">
            Retail Log
            <span>
              详情
              <img src="../../static/image/share.png" alt="">
            </span>
          </p>
          <el-row>
            <el-col :span="12">
              <div class="layout-4">
                <div class="number">
                  50
                </div>
                <div class="title">任务数量</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="layout-6">
                <div class="circle">
                  <canvas id="canvas1"></canvas>
                </div>
                <p>任务完成率</p>
              </div>
            </el-col>
          </el-row>

        </el-card>-->

    </el-row>
  </div>
</template>

<script>

  import { Chart } from '@antv/g2';
  import _ from "lodash";

  export default {
    name: 'Home',
    data () {
      return {
        toDoStatisticsVO: {
          toDoBySystems: [],
          toDoCompletionRate: 0,
          toDoTotal: 0,
        },
        doorStatisticsVO: {
          doorBySystems: [],
          doorTotal: 0,
          monthNew: 0,
        },
        accountStatisticsVO: {
          accountByRoles: [],
          accountTotal: 0,
          activeUsers: 0,
          activeDoors: 0
        },
        toolUsageVO: {
          countryCount: 0,
          listenPublishCount: 0,
          openQuestionnairesPublishCount: 0,
          oprCount: 0,
          playbookReadCount: 0,
          regions: [],
          sflReadCount: 0,
          taskCount: 0,
          vmsCount: 0,
          woUploadCount: 0,
        },
        oprStatisticsVO: {
          analyse: {
            description: "大项得分分析",
            nowOPERATION: 0,
            nowTRAINING: 0,
            nowVMS: 0,
            preOPERATION: 0,
            preTRAINING: 0,
            preVMS: 0,
            trendOPERATION: 0,
            trendTRAINING: 0,
            trendVMS: 0
          },
          count: 0,
          reportName: '',
          score: {
            description: '',
            now: 0,
            previous: 0,
            trend: 0
          }
        },
        listenStatisticsVO: {
          noPurchase: 0,
          noPurchaseCompare: 0,
          nps: 0,
          npsCompare: 0,
          osat: 0,
          osatCompare: 0,
          sampleCompare: 0,
          sampleCount: 0
        },
        chart1: null,
        chart10: null,
        chart2: null,
        chart3: null,
        chart4: null,
        chart5: null,
        chart6: null,
        chart7: null,
        month: 1,
        monthList: [{
            value: 1,
          },
          {
            value: 2,
          },
          {
            value: 3,
          },
          {
            value: 4,
          },
          {
            value: 5,
          },
          {
            value: 6,
          },
          {
            value: 7,
          },
          {
            value: 8,
          },
          {
            value: 9,
          },
          {
            value: 10,
          },
          {
            value: 11,
          },
          {
            value: 12,
          }],
      }
    },
    mounted(){
      this.getMonth()
      this.getData()
      // this.renderRate('canvas1', 70, '#ff6801', 92) // 任务完成率
      // console.log(this.$router.options.routes.filter(i=>i.path==='/')[0].children.filter(i=>i.name))
    },
    methods: {
      openSystem(systemUrl) {
        const baseUrl = this.$tool.getUrlSite()
        console.log('baseUrl', baseUrl)
        window.open(baseUrl + window[systemUrl])
      },
      getMonth() {
        const date = new Date();
        const month = date.getMonth() + 1; // 因为getMonth()返回的月份是从0开始计数的，所以需要加1
        this.month = month
      },
      async getData() {
        const month = this.month
        let res = await window.instance.post(window.retailinkUrl + '/home/' + month )
        res = res.data
        if (res.code === 200) {
          console.log('统计数据', res.data)
          this.renderTodo(res.data.toDoStatisticsVO)
          this.renderDoor(res.data.doorStatisticsVO)
          this.renderRole(res.data.accountStatisticsVO)
          this.renderOPR(res.data.oprStatisticsVO)
          this.renderTool(res.data.toolUsageVO)
          this.renderListenU(res.data.listenStatisticsVO)
          this.renderC1(res.data.toDoCompletionRateStatisticsVO)
          this.renderC2(res.data.accountActivityStatisticsVO)
          this.renderC3(res.data.accountOpenAppCountStatisticsVO)
          this.renderC4(res.data.accountOpenAppCountAvgStatisticsVO)
          this.renderC5(res.data.accountActivityByYearStatisticsVO)
          this.renderC6(res.data.accountOpenAppCountByYearStatisticsVO)
          this.renderC7(res.data.accountOpenAppCountAvgByYearStatisticsVO)
          this.renderC10(res.data.toDoTotalStatisticsVO)
          this.renderRate('canvas2', 70, '#ff6801', res.data.woStatisticsVO.currentDownload.rateNumber) // 素材下载情况
          this.renderRate('canvas3', 70, '#ff6801', res.data.woStatisticsVO.currentUsedRate.rateNumber) // 素材使用率
        }
      },
      // 切换月份
      changeMonth() {
        this.getData()
      },
      // 任务
      renderTodo(data) {
        this.toDoStatisticsVO = _.cloneDeep(data)
      },
      // 店铺
      renderDoor(data) {
        this.doorStatisticsVO = _.cloneDeep(data)
      },
      // 用户
      renderRole(data) {
        this.accountStatisticsVO = _.cloneDeep(data)
      },
      // OPR
      renderOPR(data) {
        this.oprStatisticsVO = _.cloneDeep(data)
      },
      // 工具使用情况
      renderTool(data) {
        this.toolUsageVO = _.cloneDeep(data)
      },
      // ListenU
      renderListenU(data) {
        this.listenStatisticsVO = _.cloneDeep(data)
      },
      // 任务完成率
      renderC1(data){
        if (this.chart1) {
          this.chart1.destroy()
        }
        let renderData = []
        _.each(data.thisYear, (aData) => {
          renderData.push({
            type: '本年',
            day: aData.month + '月',
            value: aData.toDoCompletionRate
          })
        })
        _.each(data.lastYear, (aData) => {
          renderData.push({
            type: '去年',
            day: aData.month + '月',
            value: aData.toDoCompletionRate
          })
        })
        /*const data = [
          { type: '本年', day: '1月', value: 98 },
          { type: '本年', day: '2月', value: 100 },
          { type: '本年', day: '3月', value: 77 },
          { type: '本年', day: '4月', value: 87 },
          { type: '本年', day: '5月', value: 87 },
          { type: '本年', day: '6月', value: 67 },
          { type: '本年', day: '7月', value: 85 },
          { type: '本年', day: '8月', value: 88 },
          { type: '本年', day: '9月', value: 83 },
          { type: '本年', day: '10月', value: 82 },
          { type: '本年', day: '11月', value: 81 },
          { type: '本年', day: '12月', value: 89 },
          { type: '去年', day: '1月', value: 100 },
          { type: '去年', day: '2月', value: 96 },
          { type: '去年', day: '3月', value: 78 },
          { type: '去年', day: '4月', value: 89 },
          { type: '去年', day: '5月', value: 76 },
          { type: '去年', day: '6月', value: 98 },
          { type: '去年', day: '7月', value: 88 },
          { type: '去年', day: '8月', value: 78 },
          { type: '去年', day: '9月', value: 73 },
          { type: '去年', day: '10月', value: 83 },
          { type: '去年', day: '11月', value: 80 },
          { type: '去年', day: '12月', value: 81 },
        ];*/
        this.chart1 = this.renderLine('chart1', renderData, true)
      },
      // 任务总量
      renderC10(data){
        if (this.chart10) {
          this.chart10.destroy()
        }
        let renderData = []
        _.each(data.thisYear, (aData) => {
          renderData.push({
            type: '本年',
            day: aData.month + '月',
            value: aData.toDoTotal
          })
        })
        _.each(data.lastYear, (aData) => {
          renderData.push({
            type: '去年',
            day: aData.month + '月',
            value: aData.toDoTotal
          })
        })
        /*const data = [
          { type: '本年', day: '1月', value: 98 },
          { type: '本年', day: '2月', value: 100 },
          { type: '本年', day: '3月', value: 77 },
          { type: '本年', day: '4月', value: 87 },
          { type: '本年', day: '5月', value: 87 },
          { type: '本年', day: '6月', value: 67 },
          { type: '本年', day: '7月', value: 85 },
          { type: '本年', day: '8月', value: 88 },
          { type: '本年', day: '9月', value: 83 },
          { type: '本年', day: '10月', value: 82 },
          { type: '本年', day: '11月', value: 81 },
          { type: '本年', day: '12月', value: 89 },
          { type: '去年', day: '1月', value: 100 },
          { type: '去年', day: '2月', value: 96 },
          { type: '去年', day: '3月', value: 78 },
          { type: '去年', day: '4月', value: 89 },
          { type: '去年', day: '5月', value: 76 },
          { type: '去年', day: '6月', value: 98 },
          { type: '去年', day: '7月', value: 88 },
          { type: '去年', day: '8月', value: 78 },
          { type: '去年', day: '9月', value: 73 },
          { type: '去年', day: '10月', value: 83 },
          { type: '去年', day: '11月', value: 80 },
          { type: '去年', day: '12月', value: 81 },
        ];*/
        this.chart10 = this.renderLine('chart10', renderData, false, false)
      },
      // 用户活跃率
      renderC2(data){
        if (this.chart2) {
          this.chart2.destroy()
        }
        let renderData = []
        _.each(data.thisMonth, (aData) => {
          renderData.push({
            name: '当月',
            role: aData.roleName,
            value: aData.activityRate
          })
        })
        _.each(data.lastMonth, (aData) => {
          renderData.push({
            name: '上月',
            role: aData.roleName,
            value: aData.activityRate
          })
        })
        /*const data = [
          { name: '当月', role: 'AHC', value: 10 },
          { name: '当月', role: 'HC', value: 5 },
          { name: '当月', role: 'RO', value: 30 },
          { name: '当月', role: 'RT', value: 85 },
          { name: '当月', role: 'NIKE INTERNAL', value: 82 },
          { name: '当月', role: 'HEADQUARTER', value: 89 },
          { name: '当月', role: 'INSTORE VMS', value: 76 },
          { name: '当月', role: 'HM', value: 80 },
          { name: '当月', role: 'Admin', value: 20 },

          { name: '上月', role: 'AHC', value: 85 },
          { name: '上月', role: 'HC', value: 25 },
          { name: '上月', role: 'RO', value: 85 },
          { name: '上月', role: 'RT', value: 70 },
          { name: '上月', role: 'NIKE INTERNAL', value: 76 },
          { name: '上月', role: 'HEADQUARTER', value: 81 },
          { name: '上月', role: 'INSTORE VMS', value: 89 },
          { name: '上月', role: 'HM', value: 80 },
          { name: '上月', role: 'Admin', value: 30 },
        ];*/
        /*const data = [
          { time: '9:00-10:00', value: 30 },
          { time: '10:00-11:00', value: 90 },
          { time: '11:00-12:00', value: 50 },
          { time: '12:00-13:00', value: 30 },
          { time: '13:00-14:00', value: 70 }
        ];*/
        this.chart2 = this.renderBar('chart2', renderData, true)
      },
      // 用户启动次数
      renderC3(data){
        if (this.chart3) {
          this.chart3.destroy()
        }
        let renderData = []
        _.each(data.thisMonth, (aData) => {
          renderData.push({
            name: '当月',
            role: aData.roleName,
            value: aData.openAppCount
          })
        })
        _.each(data.lastMonth, (aData) => {
          renderData.push({
            name: '上月',
            role: aData.roleName,
            value: aData.openAppCount
          })
        })
        /*const data = [
          { name: '当月', role: 'AHC', value: 10 },
          { name: '当月', role: 'HC', value: 5 },
          { name: '当月', role: 'RO', value: 30 },
          { name: '当月', role: 'RT', value: 85 },
          { name: '当月', role: 'NIKE INTERNAL', value: 85 },
          { name: '当月', role: 'HEADQUARTER', value: 82 },
          { name: '当月', role: 'INSTORE VMS', value: 81 },
          { name: '当月', role: 'HM', value: 60 },
          { name: '当月', role: 'ADMIN', value: 20 },

          { name: '上月', role: 'AHC', value: 85 },
          { name: '上月', role: 'HC', value: 25 },
          { name: '上月', role: 'RO', value: 85 },
          { name: '上月', role: 'RT', value: 70 },
          { name: '上月', role: 'NIKE INTERNAL', value: 76 },
          { name: '上月', role: 'HEADQUARTER', value: 70 },
          { name: '上月', role: 'INSTORE VMS', value: 67 },
          { name: '上月', role: 'HM', value: 80 },
          { name: '上月', role: 'Admin', value: 30 },
        ];*/
        this.chart3 = this.renderBar('chart3', renderData, false)
      },
      // 人均启动次数
      renderC4(data){
        if (this.chart4) {
          this.chart4.destroy()
        }
        let renderData = []
        _.each(data.thisMonth, (aData) => {
          renderData.push({
            name: '当月',
            role: aData.roleName,
            value: aData.openAppAvgCount
          })
        })
        _.each(data.lastMonth, (aData) => {
          renderData.push({
            name: '上月',
            role: aData.roleName,
            value: aData.openAppAvgCount
          })
        })
        /*const data = [
          { name: '当月', role: 'AHC', value: 10 },
          { name: '当月', role: 'HC', value: 5 },
          { name: '当月', role: 'RO', value: 30 },
          { name: '当月', role: 'RT', value: 85 },
          { name: '当月', role: 'NIKE INTERNAL', value: 81 },
          { name: '当月', role: 'HEADQUARTER', value: 89 },
          { name: '当月', role: 'INSTORE VMS', value: 84 },
          { name: '当月', role: 'HM', value: 80 },
          { name: '当月', role: 'Admin', value: 20 },

          { name: '上月', role: 'AHC', value: 85 },
          { name: '上月', role: 'HC', value: 25 },
          { name: '上月', role: 'RO', value: 85 },
          { name: '上月', role: 'RT', value: 70 },
          { name: '上月', role: 'NIKE INTERNAL', value: 87 },
          { name: '上月', role: 'HEADQUARTER', value: 76 },
          { name: '上月', role: 'INSTORE VMS', value: 78 },
          { name: '上月', role: 'HM', value: 80 },
          { name: '上月', role: 'Admin', value: 30 },
        ];*/
        this.chart4 = this.renderBar('chart4', renderData, false)
      },
      renderBar(container, data, isRate) {

        const chart = new Chart({
          container: container,
          autoFit: true,
          height: 250,
        });
        chart.data(data);
        chart.scale('value', {
          formatter: (val) => {
            if (isRate) {
              val = val + '%';
              console.log('val', val)
              return val;
            } else {
              return val;
            }
          },
          nice: true,
          range: [0, 1]
        });
        chart.tooltip({
          showMarkers: false,
          shared: true,
        });
        chart.axis('role', {
          tickLine: null,
          label: {
            autoHide: false,
            autoRotate: true
          }
        });

        chart.tooltip({
          showMarkers: false
        });
        chart.interaction('active-region');

        chart
          .interval()
          .position('role*value')
          .color('name')
          .adjust([
            {
              type: 'dodge',
              marginRatio: 0,
            },
          ])
          /*这段代码可以让数字显示在条的上面.label('value', {
            content: (originData) => {
              // console.log('originData', originData)
              return _.round(originData['value'], 0)
            },
            offset: 10,
          });*/

        chart.render();
        return chart
      },

      renderC5(data){
        if (this.chart5) {
          this.chart5.destroy()
        }
        let renderData = []
        _.each(data.thisYear, (aData) => {
          renderData.push({
            type: '今年',
            day: aData.month + '月',
            value: aData.activityRate
          })
        })
        _.each(data.lastYear, (aData) => {
          renderData.push({
            type: '去年',
            day: aData.month + '月',
            value: aData.activityRate
          })
        })
        /*const data = [
          { type: '本年', day: '1月', value: 98 },
          { type: '本年', day: '2月', value: 100 },
          { type: '本年', day: '3月', value: 77 },
          { type: '本年', day: '4月', value: 87 },
          { type: '本年', day: '5月', value: 87 },
          { type: '本年', day: '6月', value: 67 },
          { type: '本年', day: '7月', value: 85 },
          { type: '本年', day: '8月', value: 88 },
          { type: '本年', day: '9月', value: 83 },
          { type: '本年', day: '10月', value: 82 },
          { type: '本年', day: '11月', value: 81 },
          { type: '本年', day: '12月', value: 89 },
          { type: '去年', day: '1月', value: 100 },
          { type: '去年', day: '2月', value: 96 },
          { type: '去年', day: '3月', value: 78 },
          { type: '去年', day: '4月', value: 89 },
          { type: '去年', day: '5月', value: 76 },
          { type: '去年', day: '6月', value: 98 },
          { type: '去年', day: '7月', value: 88 },
          { type: '去年', day: '8月', value: 78 },
          { type: '去年', day: '9月', value: 73 },
          { type: '去年', day: '10月', value: 83 },
          { type: '去年', day: '11月', value: 80 },
          { type: '去年', day: '12月', value: 81 },
        ];*/
        this.chart5 = this.renderLine('chart5', renderData, true)
      },
      renderC6(data){
        if (this.chart6) {
          this.chart6.destroy()
        }
        let renderData = []
        _.each(data.thisYear, (aData) => {
          renderData.push({
            type: '今年',
            day: aData.month + '月',
            value: aData.openAppCount
          })
        })
        _.each(data.lastYear, (aData) => {
          renderData.push({
            type: '去年',
            day: aData.month + '月',
            value: aData.openAppCount
          })
        })
        /*const data = [
          { type: '本年', day: '1月', value: 98 },
          { type: '本年', day: '2月', value: 100 },
          { type: '本年', day: '3月', value: 77 },
          { type: '本年', day: '4月', value: 87 },
          { type: '本年', day: '5月', value: 87 },
          { type: '本年', day: '6月', value: 67 },
          { type: '本年', day: '7月', value: 85 },
          { type: '本年', day: '8月', value: 88 },
          { type: '本年', day: '9月', value: 83 },
          { type: '本年', day: '10月', value: 82 },
          { type: '本年', day: '11月', value: 81 },
          { type: '本年', day: '12月', value: 89 },
          { type: '去年', day: '1月', value: 100 },
          { type: '去年', day: '2月', value: 96 },
          { type: '去年', day: '3月', value: 78 },
          { type: '去年', day: '4月', value: 89 },
          { type: '去年', day: '5月', value: 76 },
          { type: '去年', day: '6月', value: 98 },
          { type: '去年', day: '7月', value: 88 },
          { type: '去年', day: '8月', value: 78 },
          { type: '去年', day: '9月', value: 73 },
          { type: '去年', day: '10月', value: 83 },
          { type: '去年', day: '11月', value: 80 },
          { type: '去年', day: '12月', value: 81 },
        ];*/
        this.chart6 = this.renderLine('chart6', renderData, false)
      },
      renderC7(data){
        if (this.chart7) {
          this.chart7.destroy()
        }
        let renderData = []
        _.each(data.thisYear, (aData) => {
          renderData.push({
            type: '今年',
            day: aData.month + '月',
            value: aData.openAppCount
          })
        })
        _.each(data.lastYear, (aData) => {
          renderData.push({
            type: '去年',
            day: aData.month + '月',
            value: aData.openAppCount
          })
        })
        /*const data = [
          { type: '本年', day: '1月', value: 98 },
          { type: '本年', day: '2月', value: 100 },
          { type: '本年', day: '3月', value: 77 },
          { type: '本年', day: '4月', value: 87 },
          { type: '本年', day: '5月', value: 87 },
          { type: '本年', day: '6月', value: 67 },
          { type: '本年', day: '7月', value: 85 },
          { type: '本年', day: '8月', value: 88 },
          { type: '本年', day: '9月', value: 83 },
          { type: '本年', day: '10月', value: 82 },
          { type: '本年', day: '11月', value: 81 },
          { type: '本年', day: '12月', value: 89 },
          { type: '去年', day: '1月', value: 100 },
          { type: '去年', day: '2月', value: 96 },
          { type: '去年', day: '3月', value: 78 },
          { type: '去年', day: '4月', value: 89 },
          { type: '去年', day: '5月', value: 76 },
          { type: '去年', day: '6月', value: 98 },
          { type: '去年', day: '7月', value: 88 },
          { type: '去年', day: '8月', value: 78 },
          { type: '去年', day: '9月', value: 73 },
          { type: '去年', day: '10月', value: 83 },
          { type: '去年', day: '11月', value: 80 },
          { type: '去年', day: '12月', value: 81 },
        ];*/
        this.chart7 = this.renderLine('chart7', renderData, false)
      },
      renderLine(container, data, isRate, isArea){
        // c1的数据格式:
        /* const data = [
          { type: '本周', day: 'MON', value: 0 },
          { type: '本周', day: 'TUE', value: 1 },
          { type: '本周', day: 'WED', value: 1 },
          { type: '本周', day: 'THU', value: 0.5 },
          { type: '本周', day: 'FRI', value: 1 },
          { type: '本周', day: 'SAT', value: 0 },
          { type: '本周', day: 'SUN', value: 0.8 },
          { type: '上周', day: 'MON', value: 1 },
          { type: '上周', day: 'TUE', value: 1.5 },
          { type: '上周', day: 'WED', value: 1.2 },
          { type: '上周', day: 'THU', value: 0.5 },
          { type: '上周', day: 'FRI', value: 0 },
          { type: '上周', day: 'SAT', value: 0 },
          { type: '上周', day: 'SUN', value: 0.5 },
        ]; */
        const chart = new Chart({
          container: container,
          autoFit: true,
          height: 250,
        });

        chart.data(data);
        chart.scale('day', {
          range: [0, 1],
        });
        chart.scale('value', {
          formatter: (val) => {
            if (isRate) {
              val = val + '%';
              console.log('val', val)
              return val;
            }
            else {
              return _.round(val, 2);
            }
          },
          nice: true,
        });
        chart.tooltip({
          shared: true,
          showCrosshairs: true,
        });
        chart
          .line()
          .position('day*value')
          .color('type');
        if (isArea){
          chart
            .area()
            .position('day*value')
            .color('type');
        }

        chart.render();
        return chart
      },
      renderRate: function(container, size, color, process) {
        var canvas = document.getElementById(container);
        canvas.width = 140;
        canvas.height = 140;

        var context = canvas.getContext('2d');

        // 画外圆

        context.beginPath();

        context.arc(size, size, 70, 0, Math.PI * 2);

        context.closePath();

        context.fillStyle = '#eee';

        context.fill();

        drawCricle(context, process);

        function drawCricle(ctx, percent) {

          // 进度环

          ctx.beginPath();

          ctx.moveTo(size, size);

          ctx.arc(size, size, 70, Math.PI * 1.5, Math.PI * (1.5 + 2 * percent / 100));

          ctx.closePath();

          ctx.fillStyle = color;

          ctx.fill();

          // 内圆

          ctx.beginPath();

          ctx.arc(size, size, 55, 0, Math.PI * 2);

          ctx.closePath();

          ctx.fillStyle = 'white';

          ctx.fill();

          // 填充文字

          ctx.font = "bold 24px microsoft yahei";

          ctx.fillStyle = "black";

          ctx.textAlign = "center";

          ctx.textBaseline = 'middle';

          ctx.moveTo(size, size);

          ctx.fillText(process + '%', size, size);

        }
      },

    }
  }
</script>

  <style scoped lang="scss">
  .homeContainer {
    margin: 20px;
    .row {
      margin-top: 20px
    }
    .layout-1 {
      display: flex;
      flex-direction: column;
      text-align: center;
      border-right: 1px solid #ccc;
      height: 320px;
      .icon {
        margin: 20px auto 10px;
        filter: brightness(0) saturate(100%) invert(65%) sepia(78%) saturate(450%) hue-rotate(45deg) brightness(95%) contrast(92%);
      }
      span {
        padding: 4px 0
      }
      .text-1 {
        font-size: 26px;
        padding: 0;
        font-weight: 600;
      }
      .text-2 {
        font-size: 14px;
      }
      .orange {
        color: #67c23a;
      }
      .mt-10 {
        margin-top: 10px
      }
    }
    .layout-2 {
      display: flex;
      flex-direction: column;
      text-align: center;
      span {
        padding: 10px 0
      }
      .title {
        font-weight: 500;
      }
    }
    .layout-3 {
      height: 672px
    }
    .layout-4 {
      height: 180px;
      border-right: 1px solid #ccc;
      .number {
        text-align: center;
        font-size: 40px;
        padding: 40px 0;
        font-weight: 600;
        span {
          i {
            font-size: 14px
          }
          .red {
            color: red;
          }
          .green {
            color: green;
          }
          .yellow {
            color: #ff6801
          }
        }
      }
      .title {
        text-align: center;
        font-size: 16px
      }
    }
    .layout-5 {
      margin-top: 20px;
      p {
        display: flex;
        align-items: center;
        padding: 6px 0;
        .left {
          width: 36%;
          font-size: 14px;
          text-align: right;
          margin-right: 4%;
        }
        .right {
          text-align: right;
          width: 60%;
          font-size: 30px;
          font-weight: 600;
          i {
            font-size: 14px;
          }
          .red {
            color: red;
          }
          .green {
            color: green;
          }
          .yellow {
            color: #ff6801
          }
        }
      }
    }
    .layout-6 {
      text-align: center;
      margin-top: 11px;
      .circle {
        margin: 10px auto
      }
    }
    .wait {
      height: 184px;
      font-size: 18px;
      color: #ff6801;
      line-height: 184px;
      text-align: center;
    }
    .chart1 {
      margin-top: 20px
    }
    .chart-title {
      font-size: 14px;
      color: black;
      span {
        display: flex;
        float: right;
        justify-content: center;
        color: #ff6801;
        img {
          width: 16px;
          margin-left: 4px
        }
      }
    }
    .roleCard {
      margin-left: 28px;
      height: 671px;
      overflow-y: auto;
      overflow-x: hidden;
      .roleRowHeader {
        font-weight: 600
      }
      .roleRow {
        padding: 5px 0;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #eee;
        text-align: left;
        .en {
          font-size: 12px;
          font-weight: normal;
          color: #ccc
        }
      }
    }
    .layout-7 {
      border-right: 1px solid #ccc;
      margin-top: 16px;
      height: 166px;
      p {
        padding: 10px 0
      }
    }
    .layout-8 {
      height: 166px;
      margin-top: 0px;
      p {
        padding: 8px 0
      }
    }
  }
  </style>



// WEBPACK FOOTER //
// src/pages/home.vue